import React, { useState } from "react";
import "../JobBanner/JobBanner.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faMapMarker,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const JobBanner = () => {
  return (
    <>
      <section className="Job-Tab-banner">
        <div className="container-fluid p-0">
          <div className="JobTabbanner_imgSection">
            <img
              src={
                process.env.PUBLIC_URL +
                "/assets/Images/home/candi_banner/banner.png"
              }
              className="banner-img"
              alt="..."
            />
           
          </div>
        </div>
      </section>
    </>
  );
};

export default JobBanner;
